const DrawCustomAreaIcon = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path d="M14.4999 14.5L3.62909 14.5001L3.62909 8.50012L8.49994 8.50012L8.49994 3.62923L14.4999 3.62923L14.4999 14.5Z" stroke="#0C0C0C" strokeWidth="1.5" />
            <rect x="13" y="2" width="3" height="3" fill="#0C0C0C" />
            <rect x="7" y="2" width="3" height="3" fill="#0C0C0C" />
            <rect x="7" y="7" width="3" height="3" fill="#0C0C0C" />
            <rect x="2" y="7" width="3" height="3" fill="#0C0C0C" />
            <rect x="13" y="13" width="3" height="3" fill="#0C0C0C" />
            <rect x="2" y="13" width="3" height="3" fill="#0C0C0C" />
        </svg>
    );
};

export default DrawCustomAreaIcon;
